import helpers from '../helpers/helpers';
export default {
  modelName: 'act',
  versionModelName: 'act_version',
  versionTimestampKey: 'announce_at',
  label: '法規',
  fields: {
    id: {
      type: 'text',
      label: 'ID',
      readonly: true,
    },
    is_active: {
      type: 'switch',
      label: '',
      defaultValue: true,
      activeText: '顯示',
      inactiveText: '隱藏',
    },
    act_status: {
      label: '狀態',
      type: 'belongsTo',
      textKey: 'name',
      modelName: 'act_status',
      requiredField: 'areas',
      rules: 'required',
      conditionKeys: [
        {
          fieldName: 'areas',
          conditionName: 'area',
          type: 'array',
        },
      ],
    },
    sequence: {
      type: 'text',
      label: '排序',
      maxlength: 10,
    },
    last_version: {
      type: 'last_version',
      label: '版本列表',
      modelName: 'act_version',
      showFields: ['title_mainlocale', 'updated_at'],
      fields: {
        locales: {
          type: 'locales',
          fields: {
            name: {
              type: 'text',
              label: '法規名稱',
              width: '300px',
              rules: 'required',
              maxlength: 500,
            },
            short_name: {
              type: 'text',
              label: '法規簡稱',
              maxlength: 50,
            },
            act_comment: {
              type: 'textarea',
              label: '立法總說明',
              maxlength: 10000,
            },
            status: {
              type: 'textarea',
              label: '施行狀態',
              maxlength: 10000,
            },
            ll_comment: {
              type: 'textarea',
              label: 'ESGoal總評',
              maxlength: 10000,
            },
          },
        },
        announce_at: {
          type: 'date',
          label: '修正發布日',
        },
        effect_at: {
          type: 'date',
          label: '生效日',
          rules: 'required',
        },
        reference_link: {
          type: 'link',
          label: '來源連結',
          maxlength: 500,
        },
        attaches: {
          type: 'files',
          label: '法規附件',
          uploadUrl: '/act_version/attach/',
        },
        updated_at: {
          type: 'date',
          label: '更新時間',
          readonly: true,
        },
        released_admin: {
          type: 'belongsTo',
          label: '發布人員',
          readonly: true,
          textKey: 'name',
        },
        released_at: {
          type: 'datetime',
          label: '發布時間',
          readonly: true,
        },
      },
    },
    name: {
      label: '法規名稱',
      type: 'text',
      width: '300px',
      readonly: true,
    },
    act_type: {
      label: '法律類型',
      type: 'belongsTo',
      textKey: 'name',
      modelName: 'act_type',
      requiredField: 'areas',
      rules: 'required',
      width: '150px',
      conditionKeys: [
        {
          fieldName: 'areas',
          conditionName: 'area',
          type: 'array',
        },
      ],
    },
    system_classes: {
      label: '領域',
      type: 'hasMany',
      textKey: 'name',
      modelName: 'system_class',
      requiredField: 'areas',
      width: '150px',
      rules: 'required',
      conditionKeys: [
        {
          fieldName: 'areas',
          conditionName: 'area',
          type: 'array',
        },
      ],
    },
    system_subclasses: {
      conditionKeys: [
        {
          fieldName: 'system_classes',
          conditionName: 'system_class',
          type: 'array',
        },
      ],
      requiredField: 'system_classes',
      label: '子領域',
      type: 'hasMany',
      rules: 'required',
      textKey: 'name',
      width: '150px',
      modelName: 'system_subclass',
    },
    areas: {
      label: '適用地區',
      type: 'multi-layer',
      rules: 'required',
      modelName: 'areas',
      getUrl: 'area',
      requiredField: 'area_sections',
      multiple: true,
      layersSetting: {
        modelName: 'area_sections',
        requiredFieldKey: 'area_sections',
        search: true,
      },
      getText: (data) => {
        let result = '';
        data.forEach((_data) => {
          if (result !== '') {
            result += ',';
          }
          result += _data.name;
        });
        return result;
      },
      fields: {
        modelName: 'area',
        requiredField: 'area_sections',
        layersSetting: {
          modelName: 'area_sections',
          requiredFieldKey: 'area_sections',
          search: true,
        },
      },
    },
    area_sections: {
      label: '適用子地區',
      type: 'hasMany',
      getText: (data) => {
        return data.name;
      },
    },
    industry_categories: {
      label: '適用產業類別',
      type: 'multi-layer',
      modelName: 'industry_categories',
      getUrl: 'industry_category',
      multiple: true,
      conditionKeys: [
        {
          fieldName: 'areas',
          conditionName: 'area',
          type: 'array',
        },
      ],
      fields: {
        modelName: 'industry_categories',
        getUrl: 'industry_category',
        conditionKeys: [
          {
            fieldName: 'areas',
            conditionName: 'area',
            type: 'array',
          },
        ],
      },
    },
    tags: {
      label: '標籤',
      type: 'hasMany',
      inLocale: true,
      textKey: 'name',
      modelName: 'tag',
    },
    range_type: {
      type: 'select',
      label: '適用範圍類型',
      items: [
        {
          value: 'general',
          text: '通用',
        },
        {
          value: 'exclusive',
          text: '專屬',
        },
      ],
      defaultValue: 'general',
    },
    factories: {
      type: 'hasMany',
      label: '適用工廠',
      textKey: 'name',
      modelName: 'factory',
      requiredField: 'areas',
      conditionKeys: [
        {
          fieldName: 'areas',
          conditionName: 'area',
          type: 'array',
        },
      ],
      getText: (item) => {
        return helpers.methods.$_CMS_getFactoryName(item);
      },
      displayCheck: (modelData) => {
        if (modelData.range_type === 'general') {
          return true;
        } else if (modelData.range_type === 'exclusive') {
          return false;
        }
      },
    },
    exclusive_factories: {
      type: 'hasMany',
      label: '專屬工廠',
      textKey: 'name',
      modelName: 'factory',
      requiredField: 'areas',
      conditionKeys: [
        {
          fieldName: 'areas',
          conditionName: 'area',
          type: 'array',
        },
      ],
      getText: (item) => {
        return helpers.methods.$_CMS_getFactoryName(item);
      },
      displayCheck: (modelData) => {
        if (modelData.range_type === 'general') {
          return false;
        } else if (modelData.range_type === 'exclusive') {
          return true;
        }
      },
      getRules: (modelData) => {
        if (modelData.range_type === 'exclusive') {
          return 'required';
        } else {
          return null;
        }
      },
    },
    updated_at: {
      type: 'datetime',
      label: '最後更新時間',
      readonly: true,
    },
    updated_admin: {
      type: 'belongsTo',
      label: '最後更新人',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
    act_idtf_status: {
      type: 'text',
      label: '鑑別狀態',
      readonly: true,
      textKey: 'name',
      getText: (item, fieldKey) => {
        if ( !item.last_version || !item.last_version[fieldKey]) return '從未有鑑別';
        const key = item.last_version[fieldKey];
        if (key === 'null') {
          return '從未有鑑別';
        }
        if (key === 'to_be_activated') {
          return '編輯草稿中';
        }
        if (key === 'identifying') {
          return '鑑別進行中';
        }
        if (key === 'complete') {
          return '已完成鑑別';
        }
      },
    },
    overall_owners: {
      label: '鑑別作業總負責人',
      type: 'hasMany',
      textKey: 'name',
      modelName: 'admin',
      width: '150px',
      clearable: true,
      displayCheck: ({ is_need_lawyer_idtf }) => is_need_lawyer_idtf,
      getRules: ({ is_need_lawyer_idtf }) => is_need_lawyer_idtf ? 'required' : null,
    },
    km_owners: {
      label: 'KM負責人',
      type: 'hasMany',
      textKey: 'name',
      modelName: 'admin',
      rules: 'required',
      width: '150px',
      clearable: true,
    },
    km_backups: {
      label: 'KM備員',
      type: 'hasMany',
      textKey: 'name',
      modelName: 'admin',
      rules: 'required',
      width: '150px',
      clearable: true,
    },
    km_reviewers: {
      label: 'KM覆核人',
      type: 'hasMany',
      textKey: 'name',
      modelName: 'admin',
      rules: 'required',
      width: '150px',
      clearable: true,
    },
    idtf_owners: {
      label: '鑑別負責人',
      type: 'hasMany',
      textKey: 'name',
      modelName: 'admin',
      width: '150px',
      clearable: true,
      displayCheck: ({ is_need_lawyer_idtf }) => is_need_lawyer_idtf,
      getRules: ({ is_need_lawyer_idtf }) => is_need_lawyer_idtf ? 'required' : null,
    },
    idtf_backups: {
      label: '鑑別備員',
      type: 'hasMany',
      textKey: 'name',
      modelName: 'admin',
      width: '150px',
      clearable: true,
      displayCheck: ({ is_need_lawyer_idtf }) => is_need_lawyer_idtf,
      getRules: ({ is_need_lawyer_idtf }) => is_need_lawyer_idtf ? 'required' : null,
    },
    idtf_reviewers: {
      label: '鑑別覆核人',
      type: 'hasMany',
      textKey: 'name',
      modelName: 'admin',
      width: '150px',
      clearable: true,
      displayCheck: ({ is_need_lawyer_idtf }) => is_need_lawyer_idtf,
      getRules: ({ is_need_lawyer_idtf }) => is_need_lawyer_idtf ? 'required' : null,
    },
    locales: {
      type: 'locales',
      fields: {
        name: {
          type: 'text',
          label: '法規名稱',
          width: '300px',
          rules: 'required',
          maxlength: 100,
        },
        short_name: {
          type: 'text',
          label: '法規簡稱',
          maxlength: 50,
        },
        act_comment: {
          type: 'textarea',
          label: '立法總說明',
          maxlength: 10000,
        },
        status: {
          type: 'textarea',
          label: '施行狀態',
          maxlength: 10000,
        },
        ll_comment: {
          type: 'textarea',
          label: 'ESGoal總評',
          maxlength: 10000,
        },
      },
    },
    announce_at: {
      type: 'date',
      label: '修正發布日',
    },
    effect_at: {
      type: 'date',
      label: '生效日',
      rules: 'required',
    },
    reference_link: {
      type: 'link',
      label: '來源連結',
      maxlength: 500,
    },
    attaches: {
      type: 'files',
      label: '法規附件',
      uploadUrl: '/act_version/attach/',
    },
    chips: {
      type: 'custom',
      getValue(item) {
        const chips = [];
        if (item.act_status === '廢止') {
          chips.push({
            text: '廢止',
            color: 'red',
            textColor: 'white',
            label: true,
          });
        }
        if (item.has_renew_version === 1) {
          chips.push({
            text: '!請儘速更新版本！',
            color: 'red',
            textColor: 'white',
            label: true,
          });
        }
        if (item.has_failed_url === 1) {
          chips.push({
            text: '!來源連結異常',
            color: 'red',
            textColor: 'white',
            label: true,
          });
        }
        return chips;
      },
    },
    is_released_after_content_review: {
      type: 'switch',
      label: '格式內容覆核完成後是否發布',
      defaultValue: true,
      activeText: '是',
      inactiveText: '否',
    },
    is_need_lawyer_idtf: {
      type: 'switch',
      label: '是否需要律師鑑別',
      defaultValue: true,
      activeText: '是',
      inactiveText: '否',
      displayCheck: (modelData) => modelData.is_released_after_content_review,
    },
  },
};
